<app-header *ngIf="isAuthenticated"></app-header>

<div class="content" [ngClass]="isBodyFixed ? 'fixed' : ''">
    <router-outlet></router-outlet>
</div>

<app-sidebar *ngIf="isAuthenticated"></app-sidebar>

<app-throbber></app-throbber>
